import { hashString } from '@w/utils'

/** The voice the player speaks with. Every field that changes the audio is part of
 * `ASYNC_VOICE_ID`, which keys both the server cache path and the device cache, so
 * a changed voice never plays next to audio cached under the old one. */
export const ASYNC_VOICE = {
  model: 'asyncFlashV15',
  voiceId: 'd1a08ee2-2706-4743-898c-882238036c81',
  sampleRate: 24_000,
  bitRate: 64_000,
} as const

export const ASYNC_VOICE_ID = `async-${hashString(JSON.stringify(ASYNC_VOICE))}`
